import { useState, useEffect, useContext } from "react"
import { Breadcrumbs } from "../components/global/Breadcrumbs"
import { Product } from "../components/global/Product"
import "./shop.css"
import { ProductsContext } from "../contexts/ProductsContext"

export function Shop() {
    const productsDataContext = useContext(ProductsContext)
    const { products } = productsDataContext

    const [noFilters, setNoFilters] = useState(true)

    const [filters, setFilters] = useState({
        men: { category: "Men's Clothing", on: false },
        women: { category: "Women's Clothing", on: false },
        electronics: { category: "Electronics", on: false },
        home: { category: "Home & Lifestyle", on: false },
        medecine: { category: "Medecine", on: false },
        sports: { category: "Sports & Outdoor", on: false },
        babies: { category: "Baby's & Toys", on: false },
        pets: { category: "Groceries & Pets", on: false },
        health: { category: "Health & Beauty", on: false },
        jewlery: { category: "Jewlery", on: false }
    })

    const filtersKeys = Object.keys(filters)

    function toggleFilter(filter) {
        setFilters({ ...filters, [filter]: { ...filters[filter], on: !filters[filter].on } })
    }

    useEffect(() => {
        const checkFilters = filtersKeys.map(e => filters[e].on)

        if (!checkFilters.includes(true)) {
            setNoFilters(true)
        } else {
            setNoFilters(false)
        }
    }, [filters])

    return (
        <div className="shop mx-auto mb-5">

            <Breadcrumbs dynamicPath="Shop" />

            <div className="filters d-flex justify-content-center flex-wrap gap-2">
                {
                    filtersKeys.map((e, i) => (
                        <div
                            key={i}
                            onClick={() => toggleFilter(e)}
                            className={`d-flex align-items-center gap-4 px-3 py-2 rounded-1 ${filters[e].on ? "on" : ""}`}>
                            <div>{filters[e].category}</div>
                            <i className={`fa-solid fa-x ${filters[e].on ? "" : "d-none"}`}></i>
                        </div>
                    ))
                }
            </div>

            <div className="d-flex flex-wrap justify-content-between products">
                {
                    noFilters ?
                        products && products.map((e, i) => (
                            <Product
                                key={i}
                                id={e._id}
                                name={e.title}
                                image={e.image}
                                regularPrice={e.regularPrice}
                                salePrice={e.salePrice}
                                discount={e.discount}
                                newProduct={e.new}
                                rating={e.rating.rate}
                                reviews={e.rating.reviews}
                            />
                        ))
                        :
                        filtersKeys.map(a => {
                            const filter = filters[a]

                            if (filter.on) {
                                return products && products.filter(
                                    z => z.category === filter.category.toLowerCase()
                                ).map((e, i) => (
                                    <Product
                                        key={i}
                                        id={e._id}
                                        name={e.title}
                                        image={e.image}
                                        regularPrice={e.regularPrice}
                                        salePrice={e.salePrice}
                                        discount={e.discount}
                                        newProduct={e.new}
                                        rating={e.rating.rate}
                                        reviews={e.rating.reviews}
                                    />
                                ))
                            }
                        })
                }
            </div>

        </div>
    )
}